import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';

import Contact from '../../../models/Contact';
import rightArrowIcon from '../../../images/right-arrow.svg';

/* eslint-disable react/prop-types */
const columns = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: props => <Link to={`/contacts/${props.original.id}`}>{props.value}</Link>,
  },
  {
    Header: 'Focus',
    accessor: 'focus',
  },
  {
    Header: 'Country',
    accessor: 'location',
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: props => (
      <span>
        <a href={`mailto:${props.value}`}>{props.value}</a>
      </span>
    ),
  },
  {
    Header: 'Phone Number',
    accessor: 'phoneNumber',
    Cell: props => (
      <span>
        <a href={`tel:${props.value}`}>{props.value}</a>
      </span>
    ),
  },
  {
    Header: '',
    accessor: 'id',
    width: 24,
    Cell: props => (
      <Link to={`/contacts/${props.value}`}>
        <img
          src={rightArrowIcon}
          alt="View Contact"
          style={{
            width: 16,
            height: 16,
          }}
        />
      </Link>
    ),
  },
];
/* eslint-enable react/prop-types */

class ContactTable extends React.PureComponent {
  render() {
    const { contacts, header } = this.props;

    return (
      <div>
        {header && <h4 className="title is-4">{header}</h4>}
        <ReactTable
          data={contacts}
          columns={columns}
          defaultSorted={[
            {
              id: 'name',
            },
          ]}
          showPageSizeOptions={false}
          showPageJump={false}
          defaultPageSize={10}
          minRows={1}
          className="-highlight"
        />
      </div>
    );
  }
}

ContactTable.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.instanceOf(Contact)),
  header: PropTypes.string,
};

ContactTable.defaultProps = {
  contacts: [],
  header: '',
};
export default ContactTable;



// WEBPACK FOOTER //
// ./src/components/pages/contacts/ContactTable.jsx